import React from 'react';
import { Button, Space } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const PASOS = [
  { label: 'VoBo Calidad',      tipo: 1 },
  { label: 'VoBo Operaciones',  tipo: 2 },
  { label: 'VoBo Dirección',    tipo: 3 },
  { label: 'Pagado',            tipo: 4, isPago: true },
];

export default function Autorizaciones({ data, onVobo, onPagado, disabled }) {
  if (!data) return null;

  const estatus = data.estatusAuth ?? 0;

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {PASOS.map(({ label, tipo, isPago }) => {
        const completado = estatus > tipo;
        const activo = estatus === tipo;

        return (
          <Button
            key={tipo}
            type="primary"
            icon={completado ? <CheckCircleOutlined /> : null}
            block
            size="large"
            disabled={disabled || !activo}
            onClick={() => isPago ? onPagado() : onVobo(tipo)}
          >
            {label}
          </Button>
        );
      })}
    </Space>
  );
}